var _style, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lock_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Lock_svg__st1{fill:#262a30}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lock_svg__Stroke",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Lock_svg__Stroke-Copy",
    d: "M30 0c16.6 0 30 13.4 30 30S46.6 60 30 60 0 46.6 0 30 13.4 0 30 0z",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Lock_svg__st1",
    d: "M32.4 32c-2.2 0-3.9 1.7-3.9 3.9 0 1 .4 2 1.1 2.7l-.9 5.4h7.4l-.9-5.4c.7-.7 1.1-1.7 1.1-2.7 0-2.1-1.8-3.9-3.9-3.9zm1.1 5.4l-.5.4.7 4.2H31l.7-4.2-.5-.4c-.5-.3-.8-.9-.8-1.5 0-1 .9-1.9 1.9-1.9 1.1 0 1.9.8 1.9 1.9.1.6-.2 1.2-.7 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Lock_svg__st1",
    d: "M41 27.6v-3.2c0-4.7-3.9-8.5-8.7-8.5-4.8 0-8.7 3.8-8.7 8.5v3.2c-2.3 0-4.3 1.9-4.3 4.2v12.7c0 2.3 1.9 4.2 4.3 4.2H41c2.3 0 4.3-1.9 4.3-4.2V31.7c0-2.3-1.9-4.1-4.3-4.1zm-15.3-3.3c0-3.6 3-6.5 6.7-6.5s6.7 2.9 6.7 6.5v3.2H25.7v-3.2zm17.6 20.1c0 1.2-1 2.2-2.3 2.2H23.7c-1.2 0-2.3-1-2.3-2.2V31.7c0-1.2 1-2.2 2.3-2.2H41c1.2 0 2.3 1 2.3 2.2v12.7z"
  })));
};
export default SvgLock;